<div class="investment-metric">
  <span class="metric-span">
    <b class="display-name {{ metric?.tearsheetNameStyles }}">
      {{ metric?.displayName }}:
    </b>

    <!-- Non-editable mode: show formatted value or date -->
    <span *ngIf="!metric?.isEdit; else editable">
      <span
        class="value {{ metric?.tearsheetNameStyles }}"
        [escape]="false"
        [tooltipDisabled]="hideTooltip"
        tooltipPosition="bottom"
        pTooltip="Source: {{ metric?.source ? metric.source : 'NA' }} , <br/> Quarter: {{ getQuarter(metric?.periodEndDate) }} , <br/> Last Updated: {{
          metric?.updatedAt
            ? (metric.updatedAt | date: 'shortDate' : 'UTC')
            : metric?.createdAt
            ? (metric?.createdAt | date: 'shortDate' : 'UTC')
            : 'NA'
        }}"
      >
        <ng-container *ngIf="showNAForInvalid && isInvalidValue(metric?.value, showNAForZero); else formattedValue">
          <span *ngIf="metric?.unit !== tearsheetUnit.irr; else irrMetricTemplate">N/A</span>
          <ng-template #irrMetricTemplate>
              <span>{{helper?.format(metric, millions)}}</span>
          </ng-template>

        </ng-container>

        <ng-template #formattedValue>
          <!-- Date display when NOT editing -->
          <ng-container *ngIf="metric?.isDateInput; else otherMetricsDisplay">
            {{ metric?.value ? (metric?.value | date: 'MMM. yyyy') : 'N/A' }}
          </ng-container>

          <ng-template #otherMetricsDisplay>
            <!-- Remaining Term: display computed years from stored months/days value -->
            <ng-container *ngIf="metric?.metricCode === remainingTermMetricCode; else standardDisplay">
              <span>{{ getRemainingTermDisplay(metric?.value) }}</span>
            </ng-container>

            <ng-template #standardDisplay>
              <!-- Percent unit formatting -->
              <span *ngIf="metric?.unit !== tearsheetUnit.percent">
                {{
                  (showNAForInvalid && metric?.value === 0 && !showNAForZero)
                    ? 0
                    : (metric?.value === null || metric?.value === NullString)
                    ? NullString
                    : helper?.format(metric, millions)
                }}
              </span>
              <span *ngIf="metric?.unit === tearsheetUnit.percent">
                {{
                  (showNAForInvalid && metric?.value === 0 && !showNAForZero)
                    ? 0
                    : (metric?.value === null || metric?.value === NullString)
                    ? NullString
                    : ((metric?.value * 100) | number: '1.0-1') + '%'
                }}
              </span>
            </ng-template>
          </ng-template>
        </ng-template>
      </span>
    </span>

    <!-- Editable mode -->
    <ng-template #editable>
      <ng-container *ngIf="metric?.isDateInput; else nonDateInputs">
        <!-- Editable calendar input ONLY for date metrics -->
        <p-calendar
            [(ngModel)]="metric.value"
            [showIcon]="true"
            [minDate]="minDate"
            appendTo="body"
            icon="pi pi-calendar"
            inputId="icondisplay"
            [dateFormat]="'mm/dd/yy'"
            (ngModelChange)="updateMetricValue($event)"
            ></p-calendar>

      </ng-container>

      <ng-template #nonDateInputs>
        <ng-container *ngIf="metric?.unit === tearsheetUnit.percent; else checkRatio">
          <!-- Percent input -->
          <p-inputNumber
            [ngModel]="metric?.value === NullString ? null : metric.value * 100"
            minFractionDigits="0"
            maxFractionDigits="1"
            suffix="%"
            [placeholder]="'%'"
            (onInput)="updateMetricValue($event)"
          ></p-inputNumber>
        </ng-container>

        <ng-template #checkRatio>
          <ng-container *ngIf="metric?.unit === tearsheetUnit.ratio; else checkUSD">
            <!-- Ratio input -->
            <p-inputNumber
              [ngModel]="(metric?.value === NullString || !metric?.value) ? null : metric.value"
              minFractionDigits="1"
              maxFractionDigits="1"
              suffix="x"
              (onInput)="updateMetricValue($event)"
            ></p-inputNumber>
          </ng-container>

          <ng-template #checkUSD>
            <ng-container *ngIf="metric?.unit === tearsheetUnit.USD; else checkUnitless">
              <!-- USD input -->
              <p-inputNumber
                [ngModel]="(metric?.value === NullString || !metric?.value)  ? null : metric.value"
                mode="currency"
                currency="USD"
                [placeholder]="'$'"
                (onInput)="updateMetricValue($event)"
              ></p-inputNumber>
            </ng-container>

            <ng-template #checkUnitless>
              <ng-container *ngIf="metric?.unit === tearsheetUnit.unitless; else otherUnits">
                <!-- Remaining Term: Months + Days inputs with auto-calculated decimal Years -->
                <ng-container *ngIf="metric?.metricCode === remainingTermMetricCode; else standardUnitless">
                  <div class="flex flex-column gap-1">
                    <div class="flex align-items-center gap-2">
                      <p-inputNumber
                        [(ngModel)]="remainingTermMonths"
                        [min]="0"
                        [showButtons]="false"
                        placeholder="Months"
                        [inputStyle]="{'width':'70px'}"
                        (ngModelChange)="updateRemainingTerm()"
                      ></p-inputNumber>
                      <p-inputNumber
                        [(ngModel)]="remainingTermDays"
                        [min]="0"
                        [showButtons]="false"
                        placeholder="Days"
                        [inputStyle]="{'width':'70px'}"
                        [inputStyleClass]="daysExceededMax ? 'ng-invalid ng-dirty' : ''"
                        (ngModelChange)="onDaysChange($event)"
                        (onBlur)="onDaysBlur()"
                      ></p-inputNumber>
                    </div>
                    <small *ngIf="daysExceededMax" class="p-error">Incorrect days (max 30 days)</small>
                  </div>
                </ng-container>
                <!-- Standard unitless text input for all other unitless metrics -->
                <ng-template #standardUnitless>
                  <input
                    pInputText
                    [ngModel]="metric?.value === '-0-' ? null : metric.value"
                    (ngModelChange)="updateMetricValue({ value: $event })"
                  />
                </ng-template>
              </ng-container>

              <ng-template #otherUnits>
                <!-- Other unit inputs -->
                <p-inputNumber
                  [ngModel]="(metric?.value === '-0-' || metric?.value === '') ? null : metric.value"
                  [prefix]="setUnit(metric?.unit)"
                  [minFractionDigits]="
                    metric?.unit === tearsheetUnit.Boepd || metric?.unit === tearsheetUnit.Mboe ? 1 : 0
                  "
                  [maxFractionDigits]="
                    metric?.unit === tearsheetUnit.Boepd || metric?.unit === tearsheetUnit.Mboe ? 2 : 0
                  "
                  (onInput)="updateMetricValue($event)"
                  [placeholder]="metric.unit"
                ></p-inputNumber>
              </ng-template>
            </ng-template>
          </ng-template>
        </ng-template>
      </ng-template>
    </ng-template>
  </span>
</div>
